import { Hero } from '@cinch-nx/data-storyblok'

/**
 * The content here is formatted in the same way as the parsed JSON that comes back from Storyblok.
 * I decided to structure it in this way for parity with the other landing content driven pages, and so it's ewasier to swap storyblok in later on when we have more time
 */
export const HERO_CONTENT: Hero = {
  _uid: 'b2cd3522-cded-4d4b-84ff-e9d2da866ab5',
  body: 'Choose from a wide selection of new vehicles, offers and services with Marshall Motor Group.',
  image: {
    id: 6_617_693,
    alt: 'a red audi, blue nissan, and white bmw in a row',
    name: '',
    focus: '',
    title: '',
    filename:
      'https://a.storyblok.com/f/143588/508x168/d49934308b/new-car-offers-hero.png',
    copyright: '',
    fieldtype: 'asset',
  },
  title: 'New car offers',
  component: 'GenericHero',
}

export const HERO_WITH_RICH_TEXT_CONTENT = {
  title: 'New car offers',
  body: {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [
          {
            text: 'See the latest offers and buy a brand-new car from our sister website, ',
            type: 'text',
            marks: [
              {
                type: 'textStyle',
                attrs: { color: 'rgb(25, 29, 23)' },
              },
            ],
          },
          {
            text: 'Marshall.co.uk',
            type: 'text',
            marks: [
              {
                type: 'link',
                attrs: {
                  href: 'https://www.marshall.co.uk/new-cars',
                  uuid: null,
                  anchor: null,
                  target: '_blank',
                  linktype: 'url',
                },
              },
              {
                type: 'textStyle',
                attrs: { color: 'rgb(25, 29, 23)' },
              },
            ],
          },
        ],
      },
    ],
  },
  image: {
    filename:
      'https://a.storyblok.com/f/143588/508x168/d49934308b/new-car-offers-hero.png',
    alt: 'a red audi, blue nissan, and white bmw in a row',
  },
  component: 'CarFinanceHero',
}
